// extracted by extract-css-chunks-webpack-plugin
module.exports = {"marketplaceProductCard":"_2m1mM","why-this-product":"_3lQfi"};